/**
 * @GENERATED from Figma node 693:15957
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SentryBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#584674"
      d="M2 3.667C2 2.747 2.746 2 3.667 2h16.666C21.253 2 22 2.746 22 3.667v16.666c0 .92-.746 1.667-1.667 1.667H3.667C2.747 22 2 21.254 2 20.333z"
    />
    <path
      fill="#fff"
      d="M13.693 5.718c-.124-.219-.3-.4-.511-.526a1.34 1.34 0 0 0-1.38 0c-.21.126-.386.307-.511.526L9.315 9.301c1.51.798 2.796 2 3.73 3.486a10.64 10.64 0 0 1 1.6 4.99h-1.387a9.14 9.14 0 0 0-1.415-4.265 8.47 8.47 0 0 0-3.228-2.959l-1.829 3.348a4.84 4.84 0 0 1 1.853 1.56c.484.676.8 1.47.92 2.309H6.371a.2.2 0 0 1-.106-.037.24.24 0 0 1-.077-.087.25.25 0 0 1-.003-.23l.883-1.589a3.2 3.2 0 0 0-1.01-.604l-.873 1.59a1.5 1.5 0 0 0-.139 1.104c.048.185.129.357.24.508s.249.277.406.372c.207.123.44.189.679.19h4.363a6.5 6.5 0 0 0-.518-3.085 6.1 6.1 0 0 0-1.884-2.417l.694-1.272a7.5 7.5 0 0 1 2.395 2.953 8 8 0 0 1 .698 3.821h3.697a11.97 11.97 0 0 0-1.189-5.751 11.2 11.2 0 0 0-3.74-4.358l1.403-2.543a.23.23 0 0 1 .14-.112.22.22 0 0 1 .175.026c.16.092 6.094 11.053 6.205 11.18a.25.25 0 0 1-.09.33.2.2 0 0 1-.114.03h-1.43q.027.607 0 1.211h1.436c.182.001.363-.036.531-.109q.255-.111.451-.317c.13-.137.232-.299.3-.477a1.53 1.53 0 0 0-.081-1.287z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SentryBright);
export { ForwardRef as SentryBright };
